module.exports = __webpack_public_path__ + "img/9.ce74fe39.png";